import type { CSSProperties } from 'react';

import { backgroundColors } from '../assets/colors';
import { computeColor } from './colors';

/**
 *
 * Get background style from background colors.
 *
 * Returned empty object if the parameter is `undefined`. Otherwise,
 * will return an object with a `background` property.
 *
 * @param background
 */
export const getBackgroundColorStyle = (background?: string): Pick<CSSProperties, 'background'> => {
  if (!background) return {};

  return {
    background: computeColor(background, backgroundColors),
  };
};

/**
 *
 * Get background computed color
 *
 * Returned computed color.
 *
 * @param background
 */
export const getBackgroundColor = (background?: string): string | undefined => {
  if (!background) return '';

  return computeColor(background, backgroundColors);
};

/**
 *
 * Get background darken style
 *
 * Returned object with `background` and `filter` properties.
 *
 * @param backgroundDarken
 */
export const getBackgroundDarkenStyle = (
  backgroundDarken?: number | boolean,
): Pick<CSSProperties, 'background' | 'filter'> => {
  const darkenValue = typeof backgroundDarken === 'boolean' ? (backgroundDarken ? 0.4 : 0) : backgroundDarken || 0;

  return {
    filter: `brightness(${1 - darkenValue})`,
  };
};
